import React from 'react';

/**
 * Horizontal scrollable skill tags component
 * Used in job cards to display required skills
 */
const JobSkillTags = ({
  skills = [],
  maxVisible = 5,
  showMore = true,
  onSkillClick,
  className = ''
}) => {
  // Normalize skills to array of strings
  const normalizedSkills = skills.map(skill =>
    typeof skill === 'string' ? skill : skill.name || skill.preferredLabel || ''
  ).filter(Boolean);

  const visibleSkills = normalizedSkills.slice(0, maxVisible);
  const hiddenCount = normalizedSkills.length - maxVisible;

  return (
    <div className={`relative ${className}`}>
      <div className="flex flex-wrap gap-2">
        {visibleSkills.map((skill, index) => (
          <button
            key={`${skill}-${index}`}
            onClick={(e) => {
              e.stopPropagation();
              onSkillClick?.(skill, e);
            }}
            className={`
              inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium
              bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors
              ${onSkillClick ? 'cursor-pointer' : 'cursor-default'}
            `}
          >
            {skill}
          </button>
        ))}

        {showMore && hiddenCount > 0 && (
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-500">
            +{hiddenCount} more
          </span>
        )}
      </div>
    </div>
  );
};

export default JobSkillTags;
